import Navbar from "../../components/Navbar";
import Thanks from "../../components/Thanks";
import Footer from "../../components/Footer";

const _Thanks = () => {
    return (
        <>
            <Navbar/>
            <Thanks/>
            <Footer/>
        </>
    )
}

export default _Thanks;